module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-forward-6e9c5bcb.svg";